export default "__VITE_ASSET__BPtPBQWV__"